import * as React from 'react';
import { Text } from 'office-ui-fabric-react';
import { IconButton } from 'office-ui-fabric-react';
import { SemanticIconName, SemanticIconSize } from '../Icons/SemanticIcon';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const SectionSubheading = props => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Text, {
      variant: "large",
      children: [props.children, " \xA0\xA0\xA0 "]
    }), props.onClick && /*#__PURE__*/_jsx(IconButton, {
      iconProps: {
        iconName: SemanticIconName.GoTo
      },
      size: SemanticIconSize.Medium,
      onClick: props.onClick
    })]
  });
};